export const addContentApiExpander = (config, expander, path = '') => {
  config.settings.apiExpanders.forEach((ae) => {
    if (!ae.GET_CONTENT) {
      ae.GET_CONTENT = [];
    }
    ae.GET_CONTENT.push(expander);
  });
  if (
    config.settings.apiExpanders.filter((ae) => ae.match === '').length === 0
  ) {
    config.settings.apiExpanders.push({
      match: path,
      GET_CONTENT: [expander],
    });
  }
};
